<template>
  <div>
    <div class="terminal-content-tab tab" data-tab-body="statistics">
      <div class="header-bar" data-lang-name="statistics">Statistics</div>
      <div>
        <div id="statisticsXl">
          <div class="game-holder statistics">
            <div id="statisticAll" class="clearfix">
              <div class="balls-statistic clearfix">
                <div class="balls-statistic-left">
                  <div class="chosen-balls-holder">
                    <div class="betting-holder-title">
                      <h2>
                        <span data-lang-name="hot_six"></span>
                      </h2>
                    </div>
                    <div id="hot-six-holder"></div>
                    <div class="clearfix"></div>
                    <div class="betting-holder-title balls-statistic-title">
                      <h2>
                        <span data-lang-name="the_most_common_numbers"></span>
                      </h2>
                    </div>
                  </div>
                </div>
                <div class="balls-statistic-right">
                  <div class="chosen-balls-holder">
                    <div class="betting-holder-title">
                      <h2>
                        <span data-lang-name="cold_six"></span>
                      </h2>
                    </div>
                    <div id="cold-six-holder"></div>
                    <div class="betting-holder-title balls-statistic-title">
                      <h2>
                        <span data-lang-name="the_rarest_numbers"></span>
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4">
                  <div class="betting-holder-title">
                    <h2>
                      <span data-lang-name="top_color"></span>
                    </h2>
                  </div>
                  <canvas class="chart" id="myChart1" height="100"></canvas>
                </div>
                <div class="col-lg-4">
                  <div class="betting-holder-title">
                    <h2>
                      <span data-lang-name="first_ball"></span>
                    </h2>
                  </div>
                  <canvas class="chart" id="myChart2" height="100"></canvas>
                </div>
                <div class="col-lg-4">
                  <div class="betting-holder-title">
                    <h2>
                      <span data-lang-name="last_ball"></span>
                    </h2>
                  </div>
                  <canvas class="chart" id="myChart3" height="100"></canvas>
                </div>
              </div>
              <div style="height:30px;"></div>
              <div class="row">
                <div class="col-lg-3">
                  <div class="betting-holder-title">
                    <h2>
                      <span data-lang-name="first_five_balls"></span>
                    </h2>
                  </div>
                  <div class="statistic-chars-right-first">
                    <canvas class="chart" id="myChartPie1" height="300"></canvas>
                    <div id="js-legend1" class="chartpie-legend"></div>
                  </div>
                  <div class="statistic-chars-right-second">
                    <canvas class="chart" id="myChartPie2" height="300"></canvas>
                    <div id="js-legend2" class="chartpie-legend"></div>
                  </div>
                  <div class="clearfix"></div>
                </div>
                <div class="col-lg-3">
                  <div class="betting-holder-title">
                    <h2>
                      <span data-lang-name="all_of_the_balls"></span>
                    </h2>
                  </div>
                  <div class="statistic-chars-right-first">
                    <canvas class="chart" id="myChartPie3" height="300"></canvas>
                  </div>
                  <div class="statistic-chars-right-second">
                    <canvas class="chart" id="myChartPie4" height="300"></canvas>
                  </div>
                  <div class="clearfix"></div>
                </div>
                <div class="col-lg-3">
                  <div class="betting-holder-title">
                    <h2>
                      <span data-lang-name="last_ball"></span>
                    </h2>
                  </div>
                  <div class="statistic-chars-tree">
                    <canvas class="chart" id="myChartPie8" height="300"></canvas>
                    <div id="js-legend8" class="chartpie-legend"></div>
                  </div>
                  <div class="statistic-chars-tree">
                    <canvas class="chart" id="myChartPie9" height="300"></canvas>
                  </div>
                  <div class="statistic-chars-tree">
                    <canvas class="chart" id="myChartPie10" height="300"></canvas>
                  </div>
                </div>

                <div class="col-lg-3">
                  <div class="betting-holder-title">
                    <h2>
                      <span data-lang-name="first_ball"></span>
                    </h2>
                  </div>
                  <div class="statistic-chars-tree">
                    <canvas class="chart" id="myChartPie5" height="300"></canvas>
                    <div id="js-legend5" class="chartpie-legend"></div>
                  </div>
                  <div class="statistic-chars-tree">
                    <canvas class="chart" id="myChartPie6" height="300"></canvas>
                  </div>
                  <div class="statistic-chars-tree">
                    <canvas class="chart" id="myChartPie7" height="300"></canvas>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>